import { render } from "./ThirdComponent.vue?vue&type=template&id=bd691346&scoped=true"
import script from "./ThirdComponent.vue?vue&type=script&lang=js"
export * from "./ThirdComponent.vue?vue&type=script&lang=js"

import "./ThirdComponent.vue?vue&type=style&index=0&id=bd691346&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd691346"]])

export default __exports__